import { render, staticRenderFns } from "./ScheduleForDashboard.vue?vue&type=template&id=afa59466&scoped=true"
import script from "./ScheduleForDashboard.vue?vue&type=script&lang=js"
export * from "./ScheduleForDashboard.vue?vue&type=script&lang=js"
import style0 from "./ScheduleForDashboard.vue?vue&type=style&index=0&id=afa59466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa59466",
  null
  
)

export default component.exports